import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCcStripe } from '@fortawesome/free-brands-svg-icons/faCcStripe';

export const registerBrandIcons = (library: FaIconLibrary) => {
    library.addIcons(faCcStripe);
};
